import { ModalPayloadMap, ModalPayload } from '@app/types'
import {
  AvailableModals,
  InitializedModals,
  VueModalHandlerInterface,
} from '../types'

import BaseModalHandler from './base-modal-handler'
import { mountVueModalInstance } from '../utils'
import { VueElementConstructor } from 'vue'

export default class VueModalHandler
  extends BaseModalHandler
  implements VueModalHandlerInterface
{
  private initializedModals: InitializedModals
  private availableModals: AvailableModals

  constructor(availableModals: AvailableModals) {
    super()
    this.initializedModals = {}
    this.availableModals = availableModals
  }

  open<T extends keyof ModalPayloadMap>(
    modalIdentifier: T,
    params: ModalPayload<T>
  ): void {
    const el = document.getElementById('sf-modal-portal')

    if (el) {
      const instance = mountVueModalInstance(
        this.availableModals[modalIdentifier] as VueElementConstructor,
        el
      )

      instance.openModal(params)
      this._emitModalOpened(modalIdentifier)
    }
  }

  close<T extends keyof ModalPayloadMap>(modalIdentifier: T): void {
    const modal = this.initializedModals[modalIdentifier]

    if (modal) {
      delete this.initializedModals[modalIdentifier]
    }
  }

  cleanup(): void {
    Object.keys(this.initializedModals).forEach((modalIdentifier) => {
      this.close(modalIdentifier as keyof ModalPayloadMap)
    })
  }
}
